import { css } from 'styled-components'

import { responsiveQuery } from './responsiveQuery'

export const scaffolding = css`
	*,
	*:after,
	*:before {
		box-sizing: border-box;
	}

	html {
		font-family: ${({ theme }) => theme.font.family.base};
		font-size: 100%;
		line-height: 1.428571429;
		color: ${({ theme }) => theme.color.text};
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);

		font-variant-ligatures: none;
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;

		overflow-wrap: anywhere;
	}

	body {
		background-color: ${({ theme }) => theme.color.pageBackground};
		font-size: ${({ theme }) => theme.font.size.base};
		user-select: none;
		padding: 0 24px 1em;

		${responsiveQuery.mobile(css`
			padding: 0 16px 1em;
		`)}
	}

	button,
	input,
	select,
	textarea {
		font-family: inherit;
		font-size: inherit;
		line-height: inherit;
	}

	a {
		color: ${({ theme }) => theme.color.link};
		font-weight: bold;
		text-decoration: none;

		&:focus,
		&:hover {
			color: ${({ theme }) => theme.color.link};
			text-decoration: underline;
		}

		&:focus {
			outline: 5px auto -webkit-focus-ring-color;
			outline-offset: -2px;
		}
	}

	img {
		vertical-align: middle;
	}

	hr {
		margin: ${({ theme }) => theme.font.size.base} 0;
		border: 0;
		border-top: 1px solid ${({ theme }) => theme.color.divider};
	}

	/* Remove Calendar picker icon from date fields */
	input[type="date"]::-webkit-inner-spin-button,
	input[type="date"]::-webkit-calendar-picker-indicator {
		display: none;
		appearance: none;
	}
`
